<div class="advanced-query-main">
  <h4>Create your advanced query</h4>
  <mat-dialog-content class="advance-query-container">
    <mat-form-field class="initial-tag-search">
      <mat-label>Search your tags</mat-label>
      <input matInput autocomplete="off" [(ngModel)]="initialTagSearch" (keyup)="onKeyUp($event, initialTagSearch, 'initial')">
    </mat-form-field>
    <div #selectedTags *ngIf="checkSuggestionType('initial') && searchedTags?.length > 0" class="search-results" >
      <a *ngFor="let tag of searchedTags" class="search-result" (click)="addOperator(false, tag.id)">{{tag.id}}</a>
    </div>
    <mat-form-field class="initial-operator">
      <mat-label>Choose operator</mat-label>
      <mat-select [(value)]="operator">
        <mat-option value="AND">AND</mat-option>
        <mat-option *ngIf="type !== 'exclude'" value="OR">OR</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="tag-container" *ngIf="conditions.length > 0">
      <mat-chip-grid #chipGrid>
        <mat-chip-row *ngFor="let condition of conditions; let i = index;" (removed)="deleteOperator(i)">
          {{ condition.tag }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      </mat-chip-grid>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
    <button mat-raised-button class="search-button" [mat-dialog-close]="closeDialog()">Search</button>
  </mat-dialog-actions>
</div>